/* eslint-disable */
import { useForm } from "react-hook-form"
import { DevTool } from "@hookform/devtools";

export default function SavingForm({ flowDetail, phone_details, errorShow, onSave }) {
    const { register, handleSubmit, clearErrors, control, formState: { errors } } = useForm()
    const clrErr = () => {
        if (errors.name) {
            errorShow("Bot name is required")
            clearErrors("name")
        }

        if (errors.phone_no_id) {
            errorShow("Phone Number must be required")
            clearErrors("phone_no_id")
        }
    }


    return (
        <form onSubmit={handleSubmit(onSave)}>
            <input
                {...register("name", { required: true, value: flowDetail.flow_name })}
                defaultValue={flowDetail.flow_name}
                className='form-contol m-1 p-2' placeholder='Enter the Bot Name'
            />

            <select {...register("phone_no_id", { required: true, value: flowDetail.wa_sender })} className='form-contol whait_bg_mobile m-1 p-2'>
                <option value="" selected disabled >Select Phone Number</option>
                {
                    phone_details.map(i => (
                        <option
                            selected={i.phone_no_id == flowDetail.wa_sender}
                            value={i.phone_no_id}
                        >{i.display_phone_no}</option>
                    ))
                }
            </select>
            {errors && clrErr()}
            <button type="submit" className="btn_as_my_wew ml-2"> Save </button>
            <DevTool control={control} />
        </form>
    )
}